import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUtcOffsetStore } from 'src/models/useUtcOffsetModel';
import { formatTableTopX } from 'src/utils/table';

import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { generateRedirectUrlToLog } from '@Log/shared';
import { getServiceNamesByValues } from '@Utils/service';
import { useDashboardServicesStore } from '@Models/useDashboardServicesModel';
import { LogTypeEnum } from '@Types/log';

const QuishingTop5Recipients = (props: { data: any; day: string }) => {
  const { t } = useTranslation();
  const timeModel = useUtcOffsetStore();
  const servicesModel = useDashboardServicesStore();
  const config = [
    { width: '30%', grow: 1, align: 'left', tooltip: true },
    { width: '15%', grow: 0, align: 'right' },
    { width: '30%', grow: 1, align: 'left', tooltip: true },
    { width: '20%', grow: 0, align: 'left', tooltip: true },
  ];
  const header = [
    t('dashboard.chart.column.recipient'),
    t('dashboard.chart.column.detections'),
    t('dashboard.chart.column.subject'),
    t('dashboard.chart.column.lastDetected'),
  ];

  const data = formatTableTopX(
    props.data?.quishingTopRecipient?.[props.day],
    ['key', 'total', 'subject', 'last_detected'],
    t,
    timeModel.offset
  ).map((row) => [
    row[0],
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'mergedSecurityRiskName',
              values: ['VAN_QUISHING.UMXX', 'QUISHING'],
              type: 'match',
            },
            {
              field: 'violator',
              values: [row[0] as string],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
    row[2],
    row[3],
  ]);

  return (
    <DashboardCard
      title={t('dashboard.chart.title.quishingTop5Recipients.content')}
      iconContent={t('dashboard.chart.title.quishingTop5Recipients.tooltip')}
    >
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
};

export default React.memo(QuishingTop5Recipients);
